import { render, staticRenderFns } from "./overReturnChart.vue?vue&type=template&id=227efe45&scoped=true"
import script from "./overReturnChart.vue?vue&type=script&lang=js"
export * from "./overReturnChart.vue?vue&type=script&lang=js"
import style0 from "./overReturnChart.vue?vue&type=style&index=0&id=227efe45&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227efe45",
  null
  
)

export default component.exports